<app-preloader></app-preloader>
<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>